import { createFileRoute } from "@tanstack/react-router";
import { SectionPage } from "@/components/site/SectionPage";

export const Route = createFileRoute("/unisex")({
  head: () => ({
    meta: [
      { title: "Unisex — KAKAIYS" },
      { name: "description", content: "Genderless leather pieces — bombers, café racers, briefcases and wallets that suit anyone." },
      { property: "og:title", content: "Unisex — KAKAIYS" },
      { property: "og:description", content: "Leather pieces designed beyond gender." },
      { name: "twitter:image", content: "https://tvmsfjwzfnidomctinqz.supabase.co/storage/v1/object/public/product-images/hover/noir-bomber-classique.png" },
      { property: "og:url", content: "https://kakaiys.com/unisex" },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/unisex" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Unisex — KAKAIYS",
          description: "Genderless leather pieces — bombers, café racers, briefcases and wallets.",
          url: "https://kakaiys.com/unisex",
          isPartOf: { "@id": "https://kakaiys.com/#website" },
          publisher: { "@id": "https://kakaiys.com/#organization" },
        }),
      },
    ],
  }),
  component: () => (
    <SectionPage
      eyebrow="Unisex"
      title="For Anyone."
      subtitle="Pieces designed beyond gender. Cut clean. Made to share."
      filterTag="unisex"
    />
  ),
});
